import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "animate.css/animate.min.css";
import App from "./App";
import "./css/mobile-responsive.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
